<template>
  <button
    :type="type"
    :disabled="disabled"
    :class="[
      'min-w-40 inline-flex items-center justify-center rounded-3xl font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ',
      sizeClasses,
      variantClasses,
      borderless ? '' : 'border-light-gray border',
    ]"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";

type ButtonVariant = "primary" | "outline";

const props = withDefaults(
  defineProps<{
    type?: "button" | "submit";
    variant?: ButtonVariant;
    disabled?: boolean;
    size?: "sm" | "md" | "lg";
    borderless?: boolean;
  }>(),
  {
    type: "button",
    variant: "primary",
    disabled: false,
    size: "md",
    borderless: false,
  }
);

const variantClasses = computed(() => {
  switch (props.variant) {
    case "primary":
      return "bg-bkk-50 text-mid-gray hover:bg-bkk-75 focus:ring-bg-bkk-75";
    case "outline":
      return "border border-light-gray text-mid-gray hover:bg-bkk-10 focus:ring-light-gray";
    default:
      return "";
  }
});

const sizeClasses = computed(() => {
  switch (props.size) {
    case "sm":
      return "h-8 px-3 text-sm";
    case "lg":
      return "h-12 px-6 text-base";
    default:
      return "h-10 px-4 text-sm";
  }
});
</script>
